var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _vm.list.indexOf(_vm.name) >= 0 && _vm.headerShow
        ? _c("header-com", {
            key: _vm.name,
            ref: "header",
            on: { getList: _vm.getListHandle }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "keep-alive",
        [
          _vm.$route.meta.keepAlive
            ? _c("router-view", {
                attrs: { keyword: _vm.keyword },
                on: {
                  showLoginHandle: _vm.showLoginHandle,
                  showLogin: _vm.showLogin,
                  showLoginUp: _vm.showLoginUp,
                  header: _vm.header
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      !_vm.$route.meta.keepAlive
        ? _c("router-view", {
            attrs: { keyword: _vm.keyword },
            on: {
              showLoginHandle: _vm.showLoginHandle,
              showLogin: _vm.showLogin,
              showLoginUp: _vm.showLoginUp,
              header: _vm.header
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 